module.exports = __webpack_public_path__ + "static/mercedes-9475c47fde99d3a7eabbdd049e20ba73.png";